export default __webpack_public_path__ + "static/media/icon_slogan.b96ac561.svg";